import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { numberOfItemsInRaceBox } from 'src/domains/sportsbook/webview/components/nextRaces/racesSlider/NextRacesSliderList';
import {
    CardBodyListItem,
    CardBodyWrapper,
} from 'src/domains/sportsbook/webview/components/racesSlider/greyhoundRacing/cardBody/CardBody.style';
import { CardBodyItem } from 'src/domains/sportsbook/webview/components/racesSlider/greyhoundRacing/cardBodyItem/CardBodyItem';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export interface CardBodyPropsType {
    market: MarketModel;
    sortSelections: (list: Array<SelectionModel>) => Array<SelectionModel>;
}

export const CardBody = observer('CardBody', (props: CardBodyPropsType): JSX.Element | null => {
    const { market, sortSelections } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).unifiedComponentConfig;

    const itemsForView = sortSelections(market.selections)
        .filter((x) => x.resultType !== 'void' && x.display)
        .slice(0, numberOfItemsInRaceBox);

    return (
        <CardBodyWrapper
            key='race-box-selections'
            variant={configState.componentVariants.raceCardVariant}
        >
            {itemsForView.map((selection, index) => {
                return (
                    <CardBodyListItem
                        key={`${selection.id2.toOldId()}-${index}`}
                        variant={configState.componentVariants.raceCardVariant}
                    >
                        <CardBodyItem selectionId={selection.id2} />
                    </CardBodyListItem>
                );
            })}
        </CardBodyWrapper>
    );
});
